import { render, staticRenderFns } from "./VerTestigos.vue?vue&type=template&id=0c044026&scoped=true"
import script from "./VerTestigos.vue?vue&type=script&lang=js"
export * from "./VerTestigos.vue?vue&type=script&lang=js"
import style0 from "./VerTestigos.vue?vue&type=style&index=0&id=0c044026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c044026",
  null
  
)

export default component.exports